<p-panel [toggleable]="true" [collapsed]="shouldBeCollapsed">
  <ng-template #header
    ><div>
      <i class="fa-solid fa-solar-panel mr-3"></i>Inverter info
    </div></ng-template
  >
  <p-table
    showGridlines="true"
    stripedRows
    size="small"
    [loading]="isLoading()"
    [value]="inverterList()"
  >
    <ng-template #header>
      <tr>
        <th class="lg:w-1/10 xl:w-1/12 2xl:w-1/14 3xl:w-1/16">
          <div class="text-center">
            <span class="hidden lg:inline">Status</span>
          </div>
        </th>
        <th>Name</th>
        <th>Last Update</th>
        <th>Power (W)</th>
        <th>Max Power (W)</th>
        <th class="hidden lg:table-cell">Current percentage</th>
        <th class="lg:hidden">Cur. %</th>
        <th class="hidden lg:table-cell">Target percentage</th>
        <th class="lg:hidden">Tar. %</th>
      </tr>
    </ng-template>
    <ng-template #body let-inverter let-rowIndex="rowIndex">
      <tr>
        <td
          [style]="
            iconsStyles.getDeviceStatusBackgroundStyle(
              customFunctions.getDeviceStatus(
                inverter.available,
                inverter.error,
                inverter.active
              )
            )
          "
        >
          <div class="text-center">
            <i
              [class]="
                iconsStyles.getDeviceStatusIcon(
                  customFunctions.getDeviceStatus(
                    inverter.available,
                    inverter.error,
                    inverter.active
                  )
                )
              "
              class="lg:mr-2"
            ></i
            ><span class="hidden lg:inline">{{
              customFunctions.getDeviceStatus(
                inverter.available,
                inverter.error,
                inverter.active
              )
            }}</span>
          </div>
        </td>
        <td>{{ inverter.name }}</td>
        <td>{{ inverter.lastUpdate | date : "dd-MM-yyyy, HH:mm" }}</td>
        <td>{{ inverter.watts }}</td>
        <td>{{ inverter.maxWatts }}</td>
        <td>{{ inverter.curPerc }}</td>
        <td>{{ inverter.targetPerc }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-panel>
